<template>
      <v-card xs10 flat class="grey--text caption">
          <v-card-title>
            <div>
              <h3 class="subheading">Images gallery message</h3>
              <div class="caption grey--text">{{cMessage.name}}</div>
            </div>
            <v-spacer></v-spacer> 
          <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
          </v-card-title>
          <v-divider></v-divider>
         <div class="text-xs-center">
            <v-pagination  v-if="totalpages > 1"
              v-model="currentpage"
              :length="totalpages"
            ></v-pagination>
          </div>
            <v-container class="scroll-y" style="max-height:400px" grid-list-xl>
              <div v-for="(element,index) in elements" :key="index">
                <v-card-actions v-if="page == index + 1" class="ma-0 pa-0">
                  <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-if="totalpages > 1 && currentpage > 1" flat color="grey" @click="moveGalleryCardLeft(index)" icon v-on="on">
                                <v-icon>arrow_back</v-icon>
                            </v-btn>
                        </template>  
                            <span>Move the gallery item positin to left</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-if="totalpages > 1 && currentpage < totalpages" flat color="grey" @click="moveGalleryCardRight(index)" icon v-on="on">
                                <v-icon>arrow_forward</v-icon>
                            </v-btn>
                        </template>    
                            <span>Move the gallery item position to right</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-if="totalpages < 10" @click="addNewGalleryCard" flat color="grey" icon v-on="on">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </template>    
                            <span>Add new gallery item</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn @click="deleteGalleryCard(index)" flat color="grey" icon v-on="on">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </template>  
                            <span>Delete the gallery item</span>
                      </v-tooltip>                                                                      
                </v-card-actions>
              <v-layout v-if="page == index + 1">
                <v-flex xs6> 
                  <v-textarea
                    auto-grow
                    rows="1"
                    label="Title"                
                    placeholder="Enter title"
                    counter="80"
                    v-model="element.title"
                    class="body-1 font-weight-regular"
                  ></v-textarea>
                  <v-textarea
                    auto-grow
                    rows="1"
                    label="Sub Title"                
                    placeholder="Enter sub title"
                    counter="80"
                    v-model="element.subtitle"
                    class="body-1 font-weight-regular"
                  ></v-textarea>
                  <v-textarea
                    rows="1"
                    label="Image click action"                
                    placeholder="Web URL"
                    v-model="element.default_action.url"
                    class="body-1 font-weight-regular"                                    
                    hint="Gallery card redirect url when you click on card image"
                    persistent-hint
                  ></v-textarea>
                  <v-radio-group v-if="element.default_action.url" class="justify-center mt-5" v-model="element.default_action.webview_height_ratio" row>
                              <v-radio label="Compact" value="compact" class="body-1 font-weight-regular"></v-radio>
                              <v-radio label="Tall" value="tall" class="body-1 font-weight-regular"></v-radio>
                              <v-radio label="Full" value="full" class="body-1 font-weight-regular"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs6>
                  <v-card flat class="image-upload grey--text ">
                      <label for="fileinput">                            
                        <v-img style="border: 1px solid ; border-radius: 8px; border-color: white; cursor: pointer"
                        :src="element.image_url"                        
                        :aspect-ratio="image_aspect_ratio"
                      >
                      </v-img>
                      </label>
                      <input style="display: none;" id="fileinput" type="file" @change="previewImage(index,$event)">
                      <v-card-text>Make sure that all images in this gallery are same resolution </v-card-text>                        
                      <v-radio-group class="justify-center" v-model="image_aspect_ratio" row>
                        <span class="caption mt-1 mr-2"> Image aspect ratio </span>
                          <v-radio label="1.91:1" value="1.91" class="body-1 font-weight-regular"></v-radio>
                          <v-radio label="1:1" value="1" class="body-1 font-weight-regular"></v-radio>
                      </v-radio-group>
              </v-card> 
                </v-flex>
              </v-layout> 
              <v-layout v-if="page == index + 1">
                <v-flex v-for="(button,i) in element.buttons" :key="i" xs4>
                  <v-switch
                    :label="button.label"
                    v-model="button.active"
                    @click="intializeButton(i)"
                  ></v-switch>
                  <v-card flat v-if="button.active">
                  <v-select
                      :items="buttontype"
                      label="Button Type"
                      v-model="button.type"
                      item-text="name"
                      item-value="code"
                  ></v-select>
                  <v-text-field
                    v-if="button.type != 'element_share'"
                    label="Button Title"
                    counter="20"
                    v-model="button.title"                
                  ></v-text-field>                  
                  <v-text-field
                  v-if="button.type == 'web_url'"
                    label="Button URL" 
                    v-model="button.url"             
                  ></v-text-field>
                  <v-select
                    v-if="button.type == 'web_url'"
                      :items="webviewsizes"
                      label="Web view Size"
                      v-model="button.webview_height_ratio"
                      item-text="name"
                      item-value="code"
                  ></v-select>
                  <v-text-field
                    v-if="button.type == 'phone_number'"
                    label="Phone Number"
                    placeholder="Like +918886108007" 
                    v-model="button.payload"             
                  ></v-text-field>
                  <v-select
                      v-if="button.type == 'postback'"
                      label="Link a response"
                      :items="cresponses"
                      v-model="button.response"
                      item-text="name"
                      return-object
                  ></v-select> 
                  </v-card> 
            </v-flex>
              </v-layout>
              </div>              
            <v-card-actions class="ma-0">
              <v-spacer></v-spacer> 
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>              
             </v-card-actions>
            </v-container> 
        </v-card> 
</template>

<script>
import {str} from '@/plugins/firebase.js';
import {firebase_project_id} from '@/plugins/projectvars.js'; 
export default {
  data(){
    return{
      image_aspect_ratio:"1.91",
  page:1,
  buttons:[
        {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
        {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
      ],
      buttontype:[{"name":"Link a Response","code":"postback"},{"name":"Weblink","code":"web_url"},{"name":"Phone number","code":"phone_number"},{"name":"Share","code":"element_share"}],
      webviewsizes:[{"name":"Compact","code":"compact"},{"name":"Tall","code":"tall"},{"name":"Full","code":"full"}],
      elements:[
        { "active":false,"title":null,"subtitle":null,"file":null,"image_url":"https://cdn.vuetifyjs.com/images/lists/ali.png","default_action": {
              "type": "web_url",
              "url": null,
              "webview_height_ratio": "tall",
            },
          "buttons":[
          {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
          {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
          {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
          ]
        } 
      ]
    }
  },
  computed:{
    totalpages(){
      return this.elements.length
    },
    currentpage:{
      get:function(){
        return this.page
      },
      set:function(newValue){
        this.page = newValue
      }
    },
    cMessage(){
      if(this.$store.state.bTemplateindex != null){
        return this.$store.state.bTemplateNames[this.$store.state.bTemplateindex]  
      } 
    },
    cresponses(){
        return this.$store.state.responses
    } 
  },
  methods:{
      previewImage(index,event) {
            // Reference to the DOM input element
            var input = event.target;
            this.elements[index].file = input.files[0]
            console.log(input.files[0].name)
            // Ensure that you have a file before attempting to read it
            if (input.files && input.files[0]) {
                // create a new FileReader to read this image and convert to base64 format
                var reader = new FileReader();
                // Define a callback function to run, when FileReader finishes its job
                reader.onload = (e) => {
                    // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                    // Read image as base64 and set to imageData
                    this.elements[index].image_url = e.target.result;                
                }
                // Start the reader job - read file as a data url (base64 format)
               reader.readAsDataURL(input.files[0])

            }
        },
      addNewGalleryCard(){
        if (this.elements.length < 10){
          let card ={ "active":false,"title":null,"file":null,"subtitle":null,"image_url":"https://cdn.vuetifyjs.com/images/lists/ali.png","default_action": {
              "type": "web_url",
              "url": null,
              "webview_height_ratio": "tall",
            },
          "buttons":[
          {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
          {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null},
          {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"tall","payload":null,"response":null}
          ]
         };
        this.elements.push(card)
        }
        else{
          alert("only 10 gallery cards allowed")
        }
        this.currentpage = this.elements.length
      },
      moveGalleryCardLeft(index){
        console.log(index)
        let card = this.elements[index]
        this.elements.splice(index,1)
        this.elements.splice(index-1,0,card)
        this.currentpage = index
        console.log(index)
        console.log(this.currentpage)
      },
      moveGalleryCardRight(index){
        console.log(index)
        let card = this.elements[index]
        this.elements.splice(index,1)
        this.elements.length
        this.elements.splice(index+1,0,card)
        this.currentpage = index+2
      },
      deleteGalleryCard(index){
        console.log(this.elements)
        this.elements.splice(index,1)
        this.currentpage = index
      },
      intializeButton(i){
        console.log(i)
        this.buttons[i].type = null
      },
    cancelCard(){
      let status = false
      this.$store.dispatch('abcastmenuStatusChange',status)
    },
    saveCard(){
      let index = this.$store.state.bTemplateindex
      let message = null
      let createdelements = []
      let imageStyle
      let imageAction = []
      if(this.image_aspect_ratio == '1.91'){
        imageStyle = 'horizontal'
      }
      else{
        imageStyle = 'square'
      }
        for (let element in this.elements)
          { 
            let el = {}
            el.title = this.elements[element].title
            el.subtitle = this.elements[element].subtitle

                var storageRef = str.ref();
                var d = new Date();
                var m = d.getFullYear().toString();
                var n = d.getMonth().toString();
                var o = d.getDate().toString();
                var p = d.getHours().toString();
                var q = d.getMinutes().toString();
                var r = d.getSeconds().toString();
                var s = d.getMilliseconds().toString();
                var fileName = storageRef.child(m+n+o+p+q+r+s+'.jpg').put(this.elements[element].file).then(
                el.image_url = "https://storage.googleapis.com/"+firebase_project_id+".appspot.com/"+m+n+o+p+q+r+s+'.jpg'
                )
                console.log(el.image_url)
              
             if (this.elements[element].default_action.url != null){
                el.default_action = this.elements[element].default_action
                imageAction.push(true)
             }
             else{
                imageAction.push(false)
             }
              el.buttons = []
              for (let i in this.elements[element].buttons)
              {

                if (this.elements[element].buttons[i].active == true)                
                console.log(1)
                {
                  if (this.elements[element].buttons[i].type != null && this.elements[element].buttons[i].type == "web_url")
                  {
                    console.log(2)
                    let button = {"title":this.elements[element].buttons[i].title,"type":this.elements[element].buttons[i].type,"url":this.elements[element].buttons[i].url,"webview_height_ratio":this.elements[element].buttons[i].webview_height_ratio}
                    el.buttons.push(button)
                  }
                  else if(this.elements[element].buttons[i].type != null && this.elements[element].buttons[i].type == "phone_number")
                  {
                    console.log(3)
                    let button = {"title":this.elements[element].buttons[i].title,"type":this.elements[element].buttons[i].type,"payload":this.elements[element].buttons[i].payload}
                    el.buttons.push(button)
                  }
                  else if(this.elements[element].buttons[i].type != null && this.elements[element].buttons[i].type == "element_share")
                  {
                    console.log(4)
                    let button = {"type":this.elements[element].buttons[i].type}
                    el.buttons.push(button)
                  }
                  else if(this.elements[element].buttons[i].type != null && this.elements[element].buttons[i].type == "postback")
                  {
                    console.log(5)
                    let payload = this.elements[element].buttons[i].response.id
                    let button = {"title":this.elements[element].buttons[i].title,"type":this.elements[element].buttons[i].type,"payload":payload}
                    el.buttons.push(button)
                  }                  
                }
              }             
                createdelements.push(el)
            } 

            let genericTemplate ={
                "attachment":{
                "type":"template",
                "payload":{
                  "template_type":"generic",                  
                  "image_aspect_ratio":imageStyle,
                  "elements": createdelements
                }
              }
            }
            let elementsCount = createdelements.length
           message = {"message":genericTemplate,"type":"generic","imageaction":imageAction,"currentelement":0,"elementscount":elementsCount}        
           this.$store.dispatch('acreatebcastTextMessage', {index,message})
           this.elements =[
                              { "active":false,"title":null,"subtitle":null,"file":null,"image_url":"https://cdn.vuetifyjs.com/images/lists/ali.png","default_action": {
                                    "type": "web_url",
                                    "url": null,
                                    "webview_height_ratio": "compact",
                                  },
                                "buttons":[
                                {"label":"First Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null},
                                {"label":"Second Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null},
                                {"label":"Third Button","active":false,"title":null,"type":null,"url":null,"webview_height_ratio":"compact","payload":null,"response":null}
                                ]
                              } 
                            ]
           let status = false
           this.$store.dispatch('abcastmenuStatusChange',status)
      }
  }
}
</script>
